import React, { useState, useEffect } from "react";
import { BsChevronDoubleLeft, BsChevronDoubleRight } from "react-icons/bs";
import { bgMap, textMap } from "../ColorMappingOptions";

const ColorImageCarousel = ({
  color = "orange",
  images = [],
  autoPlay = true,
  interval = 4000
}) => {
  const [current, setCurrent] = useState(0);
  const total = images.length;

  const nextSlide = () => setCurrent((prev) => (prev + 1) % total);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + total) % total);

  useEffect(() => {
    if (!autoPlay) return;
    const timer = setInterval(nextSlide, interval);
    return () => clearInterval(timer);
  }, [autoPlay, interval]);

  if (total === 0) return null;

  return (
    <div className="relative w-full mx-auto py-6 overflow-hidden">
      <div className="flex items-center justify-center relative h-[300px] lg:h-[400px]">
        {images.map((img, index) => {
          const position =
            index === current
              ? "z-20 scale-100 opacity-100"
              : index === (current - 1 + total) % total
                ? "z-10 scale-90 translate-x-[-15%] opacity-60"
                : index === (current + 1) % total
                  ? "z-10 scale-90 translate-x-[15%] opacity-60"
                  : "hidden";

          return (
            <img
              key={index}
              src={img}
              alt={`Slide ${index + 1}`}
              className={`absolute transition-all duration-700 ease-in-out rounded-xl shadow-lg object-cover h-[300px] lg:h-[400px] aspect-square ${position}`}
            />
          );
        })}
      </div>

      {/* Buttons */}
      <button
        onClick={prevSlide}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-secondary hover:bg-white rounded-full p-2 w-fit z-30"
      >
        <BsChevronDoubleLeft size={18} className={textMap[color]} />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-secondary hover:bg-white rounded-full p-2 w-fit z-30"
      >
        <BsChevronDoubleRight size={18} className={textMap[color]} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all ${bgMap[color]} ${current === index ? "scale-125" : "bg-gray-300/50"
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorImageCarousel;
